module.exports = __webpack_public_path__ + "img/edit-gray.060f5f56.svg";